import React from "react";
import Text from "@components/CustomText";
import { View } from "react-native";
import color from "@constants/color";

const SupportListSubheader = ({ title }) =>
  title ? (
    <View
      style={{
        paddingLeft: 25,
        padding: 12,
        paddingTop: 15,
        backgroundColor: color.searchBg,
      }}
    >
      <Text variant="subtitle_16">{title}</Text>
    </View>
  ) : null;

export default SupportListSubheader;
